module.exports = {
  // 登录
  login: {
    path: '/api/login',
    method: 'POST'
  },
  // 注册
  register: {
    path: '/api/register',
    method: 'POST'
  },
  // 获取验证码
  sendCode: {
    path: '/api/sendCode',
    method: 'POST'
  },
  // 获取是否匹配开始验证码滑块
  queryEnableFunction: {
    path: '/api/system/config/queryEnableFunction',
    method: 'GET'
  },
  // 获取字典选择框列表
  optionSelect: {
    path: '/api/system/dict/type/optionSelect',
    method: 'GET'
  },

  // 校验忘记密码场景下的 手机验证码
  checkCodeForForgetPassword: {
    path: '/api/checkCodeForForgetPassword',
    method: 'POST'
  },
  // 通过临时token设置密码（用于忘记密码页面，不用输入旧密码）
  setPasswordByTemporaryToken: {
    path: '/api/setPasswordByTemporaryToken',
    method: 'POST'
  },
  // 修改用户信息
  updateUserInfo: {
    path: '/api/updateUserInfo',
    method: 'POST'
  },
  // 获取颜色
  getIndexColor: {
    path: '/api/system/config/getIndexColor',
    method: 'get'
  },

  // 用户信息
  userInfo: {
    path: '/api/userInfo',
    method: 'POST'
  },
  // 导出接口建立列表
  exportResumeList: {
    path: '/api/resume/exportResumeList',
    method: 'POST'
  },
  // 文件上传
  uploadFile: {
    path: '/api/file/upload',
    method: 'POST'
  },
  // 注销账号
  accountCancellation: {
    path: '/api/accountCancellation',
    method: 'POST'
  },
  // 更换手机号
  changeMobile: {
    path: '/api/changeMobile',
    method: 'POST'
  },
  // 更改手机号 输入旧手机号场景下的 手机验证码校验
  checkCodeForChangeMobile: {
    path: '/api/checkCodeForChangeMobile',
    method: 'POST'
  },
  // 修改密码
  changePasswordForTemporaryToken: {
    path: '/api/changePasswordForTemporaryToken',
    method: 'POST'
  },
  // 身份解决绑定
  identityUnbinding: {
    path: '/api/identityUnbinding',
    method: 'POST'
  },
  // 获取服务协议、隐私政策
  getWebSiteSetInfo: {
    path: '/api/getWebSiteSetInfo',
    method: 'GET'
  },
  // 实名认证
  realNameAuthentication: {
    path: '/api/realNameAuthentication',
    method: 'POST'
  },
  // 广告
  guanggao: {
    path: '/api/advertising/management/list',
    method: 'POST'
  },



  // 公告
  notice: {
    // 获取通知公告列表
    list: {
      path: '/api/system/notice/list',
      method: 'GET'
    },
    // 根据通知公告编号获取详细信息
    notice: {
      path: '/api/system/notice/',
      method: 'GET'
    },
  },
  // 字典数据
  dictionary: {
    // 字典数据
    dictionaryZi: {
      path: '/api/system/dict/data/type/',
      method: 'GET'
    },
    configKeyZi: {
      path: '/api/system/config/configKey/',
      method: 'GET'
    },
  },
  // 双选会
  doublemeeting: {
    // 双选会-列表
    managementList: {
      path: '/api/activities/management/list',
      method: 'GET'
    },
    // 双选会-列表-已参加
    managementregisteredList: {
      path: '/api/activities/management/registeredList',
      method: 'GET'
    },
    // 双选会-查看详情
    activitiesManagement: {
      path: '/api/activities/management/',
      method: 'GET'
    },
    // 双选会-企业报名
    managementregister: {
      path: '/api/activities/management/register',
      method: 'POST'
    },
    // 双选会-企业取消报名
    managementcancelRegistration: {
      path: '/api/activities/management/cancelRegistration',
      method: 'POST'
    },
    // 双选会-职位列表
    positionList: {
      path: '/api/activities/position/list',
      method: 'GET'
    },
    // 双选会-双选会-职位-新增
    positionregister: {
      path: '/api/activities/position/register',
      method: 'POST'
    },
    // 双选会-取消职位报名
    cancelRegistration: {
      path: '/api/activities/position/cancelRegistration',
      method: 'POST'
    },
    getBusinessPositionList: {
      path: '/api/activities/position/getBusinessPositionList',
      method: 'POST'
    },
  },

  // 工作台
  workbench: {
    // 工作台-工作台企业信息
    getMyBusinessOrder: {
      path: '/api/workbench/getMyBusinessOrder',
      method: 'PUT'
    },// 工作台-查询我发布的企业职位列表
    getMyBusinessPositionList: {
      path: '/api/workbench/getMyBusinessPositionList',
      method: 'POST'
    },
    // 工作台-我的职位统计
    getMyPositionState: {
      path: '/api/workbench/getMyPositionState',
      method: 'GET'
    },
    // 工作台-我的人才统计
    getMyResumeState: {
      path: '/api/workbench/getMyResumeState',
      method: 'GET'
    },
    // 工作台-刷新职位
    refreshPositionById: {
      path: '/api/workbench/refreshPositionById/',
      method: 'PUT'
    }
  },



  // 职位接口
  position: {
    // 新增职位
    addPosition: {
      path: '/api/position/addPosition',
      method: 'POST'
    },
    // 修改职位
    editPosition: {
      path: '/api/position/editPosition',
      method: 'PUT'
    },
    // 查询企业职位列表
    getBusinessPositionList: {
      path: '/api/position/getBusinessPositionList',
      method: 'POST'
    },
    // 查询企业职位分类统计
    getBusinessPositionState: {
      path: '/api/position/getBusinessPositionState',
      method: 'GET'
    },
    // 导出接口
    export: {
      path: '/api/position/export',
      method: 'GET'
    },
    // 导入接口
    import: {
      path: '/api/position/import',
      method: 'POST'
    },
    // 获取职位发布的次数限制
    getPositionPublishLimit: {
      path: '/api/position/getPositionPublishLimit',
      method: 'GET'
    },
    // 职位查看（获取职位预览信息）
    getPreviewInfo: {
      path: '/api/position/getPreviewInfo/',
      method: 'GET'
    },
    // 场景发布列表 渠道
    getReleaseScenarioList: {
      path: '/api/position/getReleaseScenarioList',
      method: 'GET'
    },
    // 职位查看（获取修改回显信息）
    getUpdateShowInfo: {
      path: '/api/position/getUpdateShowInfo/',
      method: 'GET'
    },
    // 下线职位
    offlinePositionById: {
      path: '/api/position/offline',
      method: 'POST'
    },
    // 发布职位
    publishPositionById: {
      path: '/api/position/publishPositionById',
      method: 'PUT'
    },
    // 删除职位
    removePosition: {
      path: '/api/position/removePosition/',
      method: 'DELETE'
    },
    // 批量下线职位
    offlinePositionByIds: {
      path: '/api/position/batchOffline',
      method: 'POST'
    }
  },



  // 简历（人才）管理
  resume: {
    // 批量标记为查看
    batchSignCheck: {
      path: '/api/resume/batchSignCheck/',
      method: 'PUT'
    },
    // 批量标记为不合适
    batchSignUnSuitable: {
      path: '/api/resume/batchSignSuitable/',
      method: 'PUT'
    },
    // 获取简历详细信息
    getResumeInfo: {
      path: '/api/resume/getResumeInfo/',
      method: 'GET'
    },
    // 预览在线简历-简历信息
    getOnlineCv: {
      path: '/api/resume/getOnlineCv/',
      method: 'POST'
    },
    // 撤销不合适
    inappropriateRevocation: {
      path: '/api/resume/inappropriateRevocation/',
      method: 'PUT'
    },
    // 简历黑名单切换 > 加入黑名单
    joinTheBlacklist: {
      path: '/api/resume/joinTheBlacklist/',
      method: 'PUT'
    },
    // 获取简历列表
    list: {
      path: '/api/resume/list',
      method: 'POST'
    },
    // 简历标签统计
    resumeTabState: {
      path: '/api/resume/resumeTabState',
      method: 'GET'
    },
    // 简历是否合适切换
    switchSuitableStatus: {
      path: '/api/resume/switchSuitableStatus/',
      method: 'PUT'
    },
    // 下载简历信息
    downLoadOnlineCurl: {
      path: '/api/file/download?fileUrl=',
      method: 'GET'
    },
    // 在线简历下载
    downLoadOnlineCv: {
      path: '/api/resume/downLoadOnlineCv/',
      method: 'GET'
    },
    // 附件简历下载
    accessoryResumeDownload: {
      path: '/api/resume/accessoryResumeDownload/',
      method: 'POST'
    }
  },

  // 黑名单管理
  blacklist: {
    // 获取简历黑名单列表
    list: {
      path: '/api/blacklist/list',
      method: 'POST'
    },
    // 移出黑名单
    removeBlacklist: {
      path: '/api/blacklist/removeBlacklist/',
      method: 'PUT'
    },
    // 黑名单数量统计
    getBlackListStateCount: {
      path: '/api/blacklist/getBlackListStateCount',
      method: 'PUT'
    }
  },



  // 企业管理
  business: {
    // 添加企业用户
    addBusinessUser: {
      path: '/api/business/addBusinessUser',
      method: 'POST'
    },
    // 完善企业信息
    bindBusinessBaseInfo: {
      path: '/api/business/bindBusinessBaseInfo',
      method: 'POST'
    },
    // 企业认证
    enterpriseCertification: {
      path: '/api/business/enterpriseCertification',
      method: 'PUT'
    },
    // 获取企业认证信息
    getAuthenticationInfo: {
      // path: '/api/business/getAuthenticationInfo',
      path: '/api/business/getEnterpriseInfo',
      method: 'GET'
    },
    // 获取企业下所有的用户
    getBusinessUsers: {
      path: '/api/business/getBusinessUsers',
      method: 'GET'
    },
    // 获取角色
    getRole: {
      path: '/api/system/role/list',
      method: 'GET'
    },
    // 添加角色
    addRole: {
      path: '/api/system/role',
      method: 'POST'
    },
    // 修改角色
    updateRole: {
      path: '/api/system/role',
      method: 'PUT'
    },
    // 角色数据权限
    roleDataScope: {
      path: '/api/system/role/dataScope',
      method: 'PUT'
    },
    // 删除角色
    deleteRole: {
      path: '/api/system/role/',
      method: 'DELETE'
    },
    // 获取部门列表
    getDeptList: {
      path: '/api/system/dept/list',
      method: 'GET'
    },
    // 添加部门
    addDept: {
      path: '/api/system/dept',
      method: 'POST'
    },
    // 修改部门
    updateDept: {
      path: '/api/system/dept',
      method: 'PUT'
    },
    // 删除部门
    deleteDept: {
      path: '/api/system/dept/',
      method: 'DELETE'
    },
    // 获取部门树状结构
    roleDeptTreeselect: {
      path: '/api/system/dept/roleDeptTreeselect/',
      method: 'GET'
    },
    // 岗位负责人用户列表
    getPostLeaderList: {
      path: '/api/position/getPostLeaderList',
      method: 'GET'
    },
    // 获取企业信息
    getEnterpriseInfo: {
      path: '/api/business/getEnterpriseInfo',
      method: 'GET'
    },
    // 获取当前企业所在集团的信息
    getGroupCompanyInfo: {
      path: '/api/business/getGroupCompanyInfo',
      method: 'GET'
    },
    // 企业福利标签
    getMyEnterpriseWelfareLabel: {
      path: '/api/business/getMyEnterpriseWelfareLabel',
      method: 'GET'
    },
    // 集团下企业列表（获取我的子公司）
    getMySubsidiary: {
      path: '/api/business/getMySubsidiary',
      method: 'GET'
    },
    // 获取组织架构下将要展示的视图类型
    getViewType: {
      path: '/api/business/getViewType',
      method: 'GET'
    },
    // 企业用户邀请
    inviteUsers: {
      path: '/api/business/inviteUsers/',
      method: 'GET'
    },
    // 加入集团公司
    joinTheGroupCompany: {
      path: '/api/business/joinTheGroupCompany',
      method: 'PUT'
    },
    // 踢出企业用户
    kickOutBusinessUser: {
      path: '/api/business/kickOutBusinessUser/',
      method: 'DELETE'
    },
    // 转移 （企业用户 权限转移）
    permissionTransfer: {
      path: '/api/business/permissionTransfer/',
      method: 'PUT'
    },
    // 获取部门数据
    treeselect: {
      path: '/api/system/dept/treeselect',
      method: 'GET'
    },
    // 移除企业
    removeEnterprise: {
      path: '/api/business/removeEnterprise/',
      method: 'GET'
    },
    // 编辑/修改企业信息
    updateBusinessInfo: {
      path: '/api/business/updateBusinessInfo',
      method: 'POST'
    },
    // 编辑/修改=邮箱
    updateBusinessEmail: {
      path: '/api/business/updateBusinessEmail',
      method: 'POST'
    },
    // 修改企业用户
    updateBusinessUser: {
      path: '/api/business/updateBusinessUser',
      method: 'PUT'
    }
  },


  // 字典接口
  dictType: {
    // 招聘类型
    sys_recruitment_type: {
      path: '/api/system/dict/data/type/sys_recruitment_type',
      method: 'GET'
    },
    // 工作性质
    sys_job_type: {
      path: '/api/system/dict/data/type/sys_job_type',
      method: 'GET'
    },
    // 薪资类型
    sys_salary_tpye: {
      path: '/api/system/dict/data/type/sys_salary_tpye',
      method: 'GET'
    },
    // 期望薪资
    sys_desired_salary: {
      path: '/api/system/dict/data/type/sys_desired_salary',
      method: 'GET'
    },
    // 工作经验
    sys_work_year: {
      path: '/api/system/dict/data/type/sys_work_year',
      method: 'GET'
    },
    // 学历
    sys_education: {
      path: '/api/system/dict/data/type/sys_education',
      method: 'GET'
    },
    // 语言要求
    sys_language: {
      path: '/api/system/dict/data/type/sys_language',
      method: 'GET'
    },
    // 年龄要求
    sys_age_range: {
      path: '/api/system/dict/data/type/sys_age_range',
      method: 'GET'
    },
    // 公司行业
    sys_business_industry: {
      path: '/api/system/dict/data/type/sys_business_industry',
      method: 'GET'
    },
    // 公司福利
    sys_business_benefits: {
      path: '/api/system/dict/data/type/sys_business_benefits',
      method: 'GET'
    },
    // 公司规模
    sys_business_scale: {
      path: '/api/system/dict/data/type/sys_business_scale',
      method: 'GET'
    },
    // 企业性质
    sys_business_quality: {
      path: '/api/system/dict/data/type/sys_business_quality',
      method: 'GET'
    },
    // 公司融资阶段
    sys_business_listed: {
      path: '/api/system/dict/data/type/sys_business_listed',
      method: 'GET'
    }

  },

  // 级联查询
  cascade_dict: {
    // 查询城市列表
    city_list: {
      path: '/api/system/cascade_dict/city_list',
      method: 'GET'
    },
    // 查询职位技能管理列表
    skill_list: {
      path: '/api/system/cascade_dict/skill_list',
      method: 'GET'
    },
    // 查询级联关系字典列表  职位分类
    list: {
      path: '/api/system/cascade_dict/list',
      method: 'GET'
    }
  }
}



// WEBPACK FOOTER //
// ./src/conf/api.js